'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

require('../vendor/fullpage.parallax.min');

var _fullpageExtensions = require('fullpage.js/dist/fullpage.extensions.min');

var _fullpageExtensions2 = _interopRequireDefault(_fullpageExtensions);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Parallax = function Parallax(el) {
  (0, _classCallCheck3.default)(this, Parallax);

  setTimeout(function () {
    return new _fullpageExtensions2.default('#js-Parallax', {
      licenseKey: '00959B39-194A4B55-AD3B651A-E7CF5EA4',
      parallaxKey: 'Y2FyYXRsb25kb24uY29tX3BFTWNHRnlZV3hzWVhnPWpmUQ==',
      scrollingSpeed: 1000,
      parallax: true,
      lazyLoading: false,
      autoScrolling: true,
      parallaxOptions: {
        type: 'cover',
        percentage: 62,
        property: 'translate'
      },
      afterLoad: function afterLoad(section, origin, destination, direction, index) {
        /* eslint-disable */
        var waypoint = (0, _functional.getElement)('.par-Parallax_Waypoint');
        var skipLink = (0, _functional.getElement)('.par-Parallax_Link');
        var downArrow = (0, _functional.getElement)('.par-Parallax_ScrollDown');
        var currentSection = (0, _functional.getElement)('.fp-section.active');
        var getSection = fullpage_api.getActiveSection();
        var currentSectionIndex = getSection.index + 1;
        var totalItems = (0, _functional.getElements)('.fp-section').length;
        var hd = (0, _functional.getElement)('.hd-Header');
        var parallaxContainer = (0, _functional.getElement)('.par-Parallax');
        var parallaxMenu = (0, _functional.getElement)('.par-Parallax_Menu');

        /* Remove loading screen */
        parallaxContainer.classList.remove('par-Parallax-loading');

        /* Play text/image animations */
        currentSection.classList.add('par-Parallax_Item-animate');

        /* Hide down arrow after first slide */
        if (currentSectionIndex > 1 && currentSectionIndex < 5) {
          downArrow.classList.remove('par-Parallax_ScrollDown-hide');
        } else {
          downArrow.classList.add('par-Parallax_ScrollDown-hide');
        }

        /* Show full header if first section */
        if (currentSectionIndex <= 1) {
          hd.classList.remove('js-Header-fixed');
        }

        /* Detect slide category user is viewing */
        if (currentSectionIndex == 1) {
          parent = document.querySelector('[data-id="1"] .par-Parallax_MenuLinkIcon');
          parent.classList.add('par-Parallax_MenuLinkIcon-active');
        } else {
          parent = document.querySelector('[data-id="1"] .par-Parallax_MenuLinkIcon');
          parent.classList.remove('par-Parallax_MenuLinkIcon-active');
        }

        if (currentSectionIndex == 2) {
          parent = document.querySelector('[data-id="2"] .par-Parallax_MenuLinkIcon');
          parent.classList.add('par-Parallax_MenuLinkIcon-active');
        } else {
          parent = document.querySelector('[data-id="2"] .par-Parallax_MenuLinkIcon');
          parent.classList.remove('par-Parallax_MenuLinkIcon-active');
        }

        if (currentSectionIndex == 3) {
          parent = document.querySelector('[data-id="3"] .par-Parallax_MenuLinkIcon');
          parent.classList.add('par-Parallax_MenuLinkIcon-active');
        } else {
          parent = document.querySelector('[data-id="3"] .par-Parallax_MenuLinkIcon');
          parent.classList.remove('par-Parallax_MenuLinkIcon-active');
        }

        if (currentSectionIndex == 4) {
          parent = document.querySelector('[data-id="4"] .par-Parallax_MenuLinkIcon');
          parent.classList.add('par-Parallax_MenuLinkIcon-active');
        } else {
          parent = document.querySelector('[data-id="4"] .par-Parallax_MenuLinkIcon');
          parent.classList.remove('par-Parallax_MenuLinkIcon-active');
        }

        if (currentSectionIndex == 5) {
          parent = document.querySelector('[data-id="5"] .par-Parallax_MenuLinkIcon');
          parent.classList.add('par-Parallax_MenuLinkIcon-active');
        } else {
          parent = document.querySelector('[data-id="5"] .par-Parallax_MenuLinkIcon');
          parent.classList.remove('par-Parallax_MenuLinkIcon-active');
        }

        /* Change color of controls & pagination if class exists on section */
        if (currentSection.classList.contains('par-Parallax_Item-light')) {
          parallaxMenu.classList.add('par-Parallax_Menu-light');
        } else {
          parallaxMenu.classList.remove('par-Parallax_Menu-light');
        }
      },
      onLeave: function onLeave(section, origin, destination, direction, index) {
        var currentSection = (0, _functional.getElement)('.fp-section.active');
        var hd = (0, _functional.getElement)('.hd-Header');
        var getSection = fullpage_api.getActiveSection();
        var currentSectionIndex = getSection.index + 1;

        /* Minimise header for all sections except first */
        if (currentSectionIndex > 0) {
          hd.classList.add('js-Header-fixed');
        }

        /* Reset text/image animations */
        currentSection.classList.remove('par-Parallax_Item-animate');
      }
    });
  }, 1000);

  var next = (0, _functional.getElement)('.par-Parallax_MenuButton-next');
  var previous = (0, _functional.getElement)('.par-Parallax_MenuButton-previous');

  next.addEventListener('click', function (e) {
    fullpage_api.moveSectionDown();
  });

  previous.addEventListener('click', function (e) {
    fullpage_api.moveSectionUp();
  });
};

exports.default = Parallax;